import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Company, CompanyEnum } from '../../models/company.model';
import { CurrencyComponent } from '../currency/currency.component';
import { PriceList } from '../../models';
import { PositivelyLanguagesMoreInfoComponent } from './positively-languages-more-info/positively-languages-more-info.component';
import { AlpMoreInfoComponent } from './alp-more-info/alp-more-info.component';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule, CurrencyComponent, PositivelyLanguagesMoreInfoComponent, AlpMoreInfoComponent],
  selector: 'lx-price-lists-portal-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss'],
})
export class MoreInfoComponent {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() priceList!: PriceList;
  @Input() currency: Currency | undefined;

  companyEnum = CompanyEnum;
}
